import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvService } from '../configurations/env.service';

import {
  UserConfigurationResponse,
  UserConfigurationCreateRequest,
  UserConfigurationUpdateRequest,
  UserConfigurationDeleteResponse
} from '../../_models/users/user-configuration.models';

@Injectable({providedIn: 'root'})
export class UserService {
  private environment = inject(EnvService);
  private apiURL = this.environment?.readConfig()?.apiUrl;

  constructor(private http: HttpClient) { }

  listUserConfigurations(params: {base: number; type: string}): Observable<UserConfigurationResponse[]> {
    let httpParams = new HttpParams()
      .set('base', params.base)
      .set('type', params.type);

    return this.http.get<UserConfigurationResponse[]>(`${this.apiURL}/user-configuration`,{ params: httpParams, withCredentials: true }
    );
  }

  getUserConfiguration(id: number): Observable<UserConfigurationResponse> {
    return this.http.get<UserConfigurationResponse>(`${this.apiURL}/user-configuration/${id}`,{ withCredentials: true });
  }

  createUserConfiguration(body: UserConfigurationCreateRequest): Observable<UserConfigurationResponse> {
    return this.http.post<UserConfigurationResponse>(`${this.apiURL}/user-configuration`,body,{ withCredentials: true });
  }

  updateUserConfiguration(id: number, body: UserConfigurationUpdateRequest): Observable<UserConfigurationResponse> {
    return this.http.put<UserConfigurationResponse>(`${this.apiURL}/user-configuration/${id}`,body,{ withCredentials: true });
  }

  deleteUserConfiguration(id: number): Observable<UserConfigurationDeleteResponse> {
    return this.http.delete<UserConfigurationDeleteResponse>(`${this.apiURL}/user-configuration/${id}`,{ withCredentials: true });
  }
}
